import styled, { css } from 'styled-components'
import { themeMedia, themeStyles } from '../../../styles/theme'

const grey = '#dbdbdb'

export const StyledWrapper = styled.label`
  display: flex;
  align-items: center;
  padding: 10px 0px;
  border-bottom: 1px solid ${grey};
  gap: 25px;
  cursor: pointer;

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  ${themeMedia.tablet`
    padding: 15px 24px;
    gap: 50px;
  `}
`

export const StyledRadio = styled.div`
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  flex-grow: 1;
  border-radius: 50%;
  box-sizing: border-box;
  border: 3px solid ${themeStyles.colors.accentColors.primary.main};
  padding: 2px;

  &:before {
    content: '';
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: ${themeStyles.colors.accentColors.primary.main};
  }

  ${({ $checked }) =>
    !$checked &&
    css`
      border-color: ${grey};
      &:before {
        background-color: ${grey};
      }
    `}
`

export const StyledContent = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`
